import React, { useEffect } from 'react'
import ConsentGate from './ConsentGate'

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    instgrm?: {
      Embeds: {
        process: () => void
      }
    }
  }
}

interface InstagramEmbedProps {
  postId: string
  className?: string
}

const InstagramEmbedContent: React.FC<InstagramEmbedProps> = ({
  postId,
  className = ''
}) => {
  useEffect(() => {
    // Load Instagram embed script if not already loaded
    if (typeof window !== 'undefined' && !window.instgrm) {
      const script = document.createElement('script')
      script.src = 'https://www.instagram.com/embed.js'
      script.async = true
      document.body.appendChild(script)
    } else if (typeof window !== 'undefined' && window.instgrm) {
      window.instgrm.Embeds.process()
    }
  }, [postId])

  return (
    <div className={`my-6 flex justify-center ${className}`}>
      <blockquote
        className="instagram-media"
        data-instgrm-captioned
        data-instgrm-permalink={`https://www.instagram.com/p/${postId}/`}
        data-instgrm-version="14"
        style={{
          background: '#FFF',
          border: 0,
          borderRadius: '3px',
          boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
          margin: '1px',
          maxWidth: '540px',
          minWidth: '326px',
          padding: 0,
          width: '100%'
        }}
      />
    </div>
  )
}

const InstagramEmbed: React.FC<InstagramEmbedProps> = ({
  postId,
  className = ''
}) => {
  return (
    <ConsentGate
      type="instagram"
      serviceName="Instagram"
      controllerName="Instagram"
      description="Instagram is owned by Meta (Facebook) and uses cookies for tracking, analytics, and advertising. Meta may use your interaction with this content for targeted advertising across their services and partner websites."
      className={className}
    >
      <InstagramEmbedContent postId={postId} className={className} />
    </ConsentGate>
  )
}

export default InstagramEmbed